<template>
  <div v-if="showModal" class="cookies">
    <div class="cookies__container container">
      <div class="cookies__content">
        <p class="cookies__text">
          Для доступа на сайт необходимо подтвердить согласие на 
          <a 
            href="/Privacy_Policy_processing_of_personal_data.pdf"
            target="_blank"
            class="cookies__link"
          >
          обработку персональных данных, осуществляемую с 
          использованием файлов  cookies и сервиса веб-аналитики 
          «Яндекс Метрика»</a>.
        </p>
      </div>

      <div class="cookies__buttons">
        <button class="btn-common violet-btn cookies__button" @click="acceptAllCookies">
          <span>Подтверждаю</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const LOCAL_STORAGE_KEY = 'cookiesConsent';
const YM_COUNTER_ID = 55800748;

export default {
  data() {
    return {
      showModal: false,
    };
  },
  created() {
    const consent = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!consent) {
      this.showModal = true;
    } else {
      const parsed = JSON.parse(consent);
      if (parsed.all) {
        this.loadYandexMetrika();
      }
    }
  },
  methods: {
    acceptAllCookies() {
      this.closeMessage();
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
        all: true,
        necessary: true,
      }));
      this.loadYandexMetrika();
    },
    closeMessage() {
      this.showModal = false;
    },
    loadYandexMetrika() {
      if (window.ym) return;

      try {
        (function(m,e,t,r,i,k,a){
          m[i]=m[i]||function(){ (m[i].a=m[i].a||[]).push(arguments) };
          m[i].l=1*new Date();
          k=e.createElement(t), a=e.getElementsByTagName(t)[0],
          k.async=1; k.src=r; a.parentNode.insertBefore(k,a);
        })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(YM_COUNTER_ID, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true,
        });

        const noscript = document.createElement('noscript');
        const noscriptContent = document.createElement('div');
        const pixel = document.createElement('img');
        
        pixel.src = `https://mc.yandex.ru/watch/${YM_COUNTER_ID}`;
        pixel.style.position = 'absolute';
        pixel.style.left = '-9999px';
        pixel.alt = '';
        
        noscriptContent.appendChild(pixel);
        noscript.appendChild(noscriptContent);

        document.body.insertBefore(noscript, document.body.firstChild);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>


<style lang="scss" scoped>
@use '@/styles/constants.scss' as *;

.cookies {
  position: fixed;
  z-index: 1001;
  background-color: rgba($color: #000000, $alpha: 0.24);
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 14px;

  &__container {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    background-color: #fff;
    color: #000;
    padding: 2em;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
  &__text {
    color: #000;
    margin-bottom: 0.5em;
  }

  &__link {
    color: #000;
    text-decoration: underline;
    cursor: pointer;
  }

  &__buttons {
    display: flex;
    justify-content: center;
    gap: 1em;
  }

  &__button {
    flex-shrink: 0;
    width: auto;
    height: auto;
    font-size: 1em;
    padding: 1em 2em;
  }
}

@media (max-width: 1200px) {
  .cookies {
    font-size: 13px;
  }
}

@media (max-width: 800px) {
  .cookies {
    font-size: 12px;

    &__container {
      max-height: max-content;
      bottom: 1em;
      padding: 1.2em;
      flex-direction: column;
      align-items: center;
      gap: 1.4em;
    }

    &__content {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      padding-right: 8px;
    }

    &__buttons {
      flex-wrap: wrap;
      gap: 0.5em;
    }

    &__button {
      width: 100%;
    }
  }
}
</style>
